import { useMemo } from "react";
import intl from "react-intl-universal";
import qs from "qs";
import { useHistory, useLocation } from "react-router-dom";
import { PageHeaderWithBack } from "../../../../Components/Molecules";
import { useToast } from "../../../../Hooks/toast";
import { BaasEntidadePersonalCreateForm } from "./components/BaasEntidadePersonalCreateForm";
import { ENTIDADES_LIST_PATH } from "./BaasEntidadeCreatePage";

export const ENTIDADES_PERSONAL_CREATE_PATH = "/baas/entidades/nova/pessoal";

const isQueryTruthy = (value) =>
  value === true || value === "true" || value === "1" || value === "on";

const parsePersonalCreateSearch = (search) => {
  const parsed = qs.parse(String(search || "").replace("?", ""));
  return {
    debugConsoleExpanded: isQueryTruthy(parsed.json),
  };
};

const buildPersonDetailPath = (entityId) =>
  `/baas/entidades/${encodeURIComponent(entityId)}`;

export const BaasEntidadePersonalCreatePage = () => {
  const history = useHistory();
  const location = useLocation();
  const { addToast } = useToast();

  const { debugConsoleExpanded } = useMemo(
    () => parsePersonalCreateSearch(location.search),
    [location.search],
  );

  const handleCreated = (entity) => {
    const persId = String(entity?.id || "").trim();
    const personPath =
      persId.toLowerCase().startsWith("pers_") ? buildPersonDetailPath(persId) : null;
    addToast({
      type: "success",
      title: intl.get("baas.entidades.personal.success"),
      description: persId
        ? intl.get("baas.entidades.personal.successOpenPerson", { id: persId })
        : undefined,
      linkTo: personPath || undefined,
      linkLabel: personPath
        ? intl.get("baas.entidades.create.openPersonInConsole")
        : undefined,
    });
    if (personPath) {
      history.push(personPath, { entityCreated: true });
      return;
    }
    history.push(ENTIDADES_LIST_PATH, { entityCreated: true });
  };

  return (
    <div className="baas-entidade-personal-create w-full min-w-0">
      <PageHeaderWithBack
        title={intl.get("baas.entidades.personal.pageTitle")}
        subTitle={intl.get("baas.entidades.personal.subtitle")}
        backTo={ENTIDADES_LIST_PATH}
      />

      <BaasEntidadePersonalCreateForm
        active
        debugConsoleExpanded={debugConsoleExpanded}
        onCreated={handleCreated}
      />
    </div>
  );
};
